// @flow
import { QuestionTypesOpinometroActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    questionTypeOpinometro: {},
    listaQuestionTypesOpinometro: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type QuestionTypesOpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { questionTypeOpinometro?: {} | null, listaQuestionTypesOpinometro?: [] | null, loading?: boolean, +value ?: boolean };

const QuestionTypesOpinometro = (state: State = INIT_STATE, action: QuestionTypesOpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case QuestionTypesOpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        questionTypeOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO: {
                    return {
                        ...state,
                        listaQuestionTypesOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionTypesOpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        questionTypeOpinometro: {},
                        loading: false,
                    };
                }
                case QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaQuestionTypesOpinometro: [],
                        loading: false,
                    };
                }
                case QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case QuestionTypesOpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                questionTypeOpinometro: {},
                listaQuestionTypesOpinometro: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default QuestionTypesOpinometro;
